document.querySelectorAll("[data-identity-slider-root]").forEach(function(root){
  var input=root.querySelector("[data-identity-slider]");
  if(!input)return;
  var pointerId=null;
  var startX=0;
  var startY=0;
  var pending=false;
  var dragging=false;
  var clamp=function(value){return Math.max(0,Math.min(100,value));};
  var update=function(){
    var value=clamp(Number(input.value)||0);
    input.value=String(value);
    input.setAttribute("aria-valuenow",String(Math.round(value)));
    input.setAttribute("aria-valuetext",Math.round(value)+"% comparison");
    root.style.setProperty("--lds-showcase-position",value+"%");
  };
  var setValue=function(value){
    input.value=String(clamp(value));
    update();
  };
  var setFromClientX=function(clientX){
    var rect=root.getBoundingClientRect();
    if(!rect.width)return;
    setValue(((clientX-rect.left)/rect.width)*100);
  };
  var capture=function(event){
    dragging=true;
    pending=false;
    root.setAttribute("data-identity-dragging","true");
    if(root.setPointerCapture){
      try{root.setPointerCapture(event.pointerId);}catch(error){}
    }
  };
  var finish=function(event){
    if(pointerId===null||event.pointerId!==pointerId)return;
    if(root.releasePointerCapture&&root.hasPointerCapture&&root.hasPointerCapture(pointerId)){
      try{root.releasePointerCapture(pointerId);}catch(error){}
    }
    pointerId=null;
    pending=false;
    dragging=false;
    root.removeAttribute("data-identity-dragging");
  };
  root.addEventListener("pointerdown",function(event){
    if(pointerId!==null)return;
    if(event.pointerType==="mouse"&&event.button!==0)return;
    pointerId=event.pointerId;
    startX=event.clientX;
    startY=event.clientY;
    pending=event.pointerType==="touch";
    if(!pending){
      capture(event);
      setFromClientX(event.clientX);
      event.preventDefault();
    }
  },{passive:false});
  root.addEventListener("pointermove",function(event){
    if(pointerId===null||event.pointerId!==pointerId)return;
    var deltaX=event.clientX-startX;
    var deltaY=event.clientY-startY;
    if(pending){
      if(Math.max(Math.abs(deltaX),Math.abs(deltaY))<6)return;
      if(Math.abs(deltaY)>Math.abs(deltaX)){
        finish(event);
        return;
      }
      capture(event);
    }
    if(!dragging)return;
    setFromClientX(event.clientX);
    event.preventDefault();
  },{passive:false});
  root.addEventListener("pointerup",function(event){
    if(pointerId===null||event.pointerId!==pointerId)return;
    if(pending&&Math.max(Math.abs(event.clientX-startX),Math.abs(event.clientY-startY))<6){
      setFromClientX(event.clientX);
    }else if(dragging){
      setFromClientX(event.clientX);
    }
    finish(event);
  },{passive:false});
  root.addEventListener("pointercancel",finish);
  input.addEventListener("keydown",function(event){
    var value=Number(input.value)||0;
    if(event.key==="ArrowLeft"){setValue(value-1);}
    else if(event.key==="ArrowRight"){setValue(value+1);}
    else if(event.key==="Home"){setValue(0);}
    else if(event.key==="End"){setValue(100);}
    else{return;}
    event.preventDefault();
  });
  input.addEventListener("input",update);
  window.addEventListener("resize",update);
  update();
});